import { observer } from 'mobx-react-lite';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import * as React from 'react';
import DataRow from 'owa-calendar-forms-common/lib/components/DataRow';
import { ControlIcons } from 'owa-control-icons';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';
import { Link } from '@fluentui/react/lib/Link';
import generateLinkStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateLinkStyle';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { showCollabSpace } from './PeekEventContent.locstring.json';
import loc from 'owa-localize';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

interface PeekEventCollabSpaceRowProps {
    event: CalendarEvent;
    colorScheme: ColorScheme;
    onOpenEventClicked: (
        ev?: React.MouseEvent<HTMLElement>,
        shouldScrollToInsights?: boolean
    ) => void;
}

const styles = require('./CalendarItemPeek.scss');

export default observer(function PeekEventCollabSpaceRow(props: PeekEventCollabSpaceRowProps) {
    const { event, colorScheme, onOpenEventClicked } = props;
    const showCollabSpaceLink = shouldShowCollabSpaceLink(event.CollabSpace);

    const onClick = (ev?: React.MouseEvent<HTMLElement>) => {
        logUsage('CollabSpaceOpenedFromPeekLink', undefined, { isCore: true });
        onOpenEventClicked(ev);
    };

    return (
        isFluidEnabledForSource(FluidOwaSource.CalendarReadingPane) &&
        showCollabSpaceLink && (
            <DataRow
                className={styles.collabSpaceRow}
                iconName={ControlIcons.OneNoteLogo}
                iconClassName={styles.collabSpaceIcon}>
                <Link
                    styles={generateLinkStyle(colorScheme)}
                    onClick={onClick}
                    className={styles.collabSpaceLink}>
                    {loc(showCollabSpace)}
                </Link>
            </DataRow>
        )
    );
});

function shouldShowCollabSpaceLink(collabSpace: string): boolean {
    let showCollabSpaceLink: boolean = false;
    if (!collabSpace) {
        return showCollabSpaceLink;
    }
    try {
        const parsedCollabSpace = JSON.parse(collabSpace);
        if (parsedCollabSpace) {
            const { location, metadata } = parsedCollabSpace;
            if (location && metadata?.state === 'Enabled') {
                showCollabSpaceLink = true;
            }
        }
    } catch (e) {
        trace.warn('Unable to parse collab space in calendar event: ' + collabSpace);
    }
    return showCollabSpaceLink;
}
